import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  strict: true,
  state: {
    user: {
      name: "",
      credentials: "",
      master: "",
      token: ""
    }
  },
  getters,
  mutations,
  actions
};
